document.addEventListener('preloaded', function (event) {
    const categoryFilters = $('.js-category-filter');
    const activeCurrentCategory = $('.js-category-filter.active');

    // Hide category filter if has no news by this category
    if (categoryFilters.length > 0) {
        categoryFilters.each((i, el) => {
            const category = $(el).data('category');
            const hasNoNewsByCategories = $('.js-filterable[data-categories*=' + category + ']').length == 0;

            if (hasNoNewsByCategories && category != 'all') {
                $(el).parents('.nav-item').hide();
            }
        });
    }

    // Filter: list on load with active category
    if (activeCurrentCategory.length > 0) {
        filterNewsListByActiveFilter(activeCurrentCategory);
    }
}, false);

// Filter: specific by clicked category
$('.js-category-filter').on('click', function () {
    $('.js-category-filter').removeClass(['active', 'border-primary', 'fw-bold']).addClass(['bg-transparent', 'text-gray-verydark', 'border-dark']);
    $(this).addClass(['active', 'border-primary', 'fw-bold']).removeClass(['bg-transparent', 'text-gray-verydark', 'border-dark']);

    filterNewsListByActiveFilter(this);
});

function filterNewsListByActiveFilter(currentFilter) {
    const category = $(currentFilter).data('category');
    const limit = $('.news--list').data('limit');
    const isAllSelected = category == 'all';

    if (isAllSelected) {
        // Show all
        $('.news--list').find('.js-filterable.show-all').removeClass('d-none').addClass('d-block');
        $('.news--list').find('.js-filterable.show-limited').removeClass('d-none').addClass(['d-block', 'show-limited']);

        // Show all on limited list
        $('.news--list').find('.js-filterable.show-limited').each((i, el) => {
            const index = i + 1;

            if (index > limit) {
                $(el).removeClass(['d-block', 'show-limited']).addClass(['d-none', 'hide']);
            }
        });
    } else {
        // Reset Filter
        $('.news--list').find('.js-filterable.show-all').removeClass('d-block').addClass('d-none');
        $('.news--list').find('.js-filterable[data-categories*=' + category + '].show-all').removeClass('d-none').addClass('d-block');
        $('.news--list').find('.js-filterable.show-limited').removeClass('d-block').addClass('d-none');

        // Filter list on category
        const showLimitedNewsCategories = $('.news--list').find('.js-filterable[data-categories*=' + category + '].show-limited');
        showLimitedNewsCategories.removeClass('d-none')
            .addClass(['d-block', 'show-limited']);

        // Hide filtered items on limited list
        $('.news--list').find('.js-filterable[data-categories!=' + category + '].show-limited.hide').removeClass(['d-block', 'show-limited'])
            .addClass(['hide', 'd-none']);

        // Update with not reached limit
        const hasNotReachedLimit = $('.news--list').find('.js-filterable[data-categories*=' + category + '].show-limited').length < limit;
        if (hasNotReachedLimit) {
            // Show last next hidden element to fill up limit
            $('.js-filterable[data-categories*=' + category + '].show-limited').last().next('.hide')
                .removeClass(['d-none', 'hide']).addClass(['show-limited', 'd-block']);
        }
    }

    // Push filter query to url
    const urlSearchParams = new URLSearchParams(window.location.search);
    const filterName = 'filter-category';

    urlSearchParams.set(filterName, category);

    const hasUrlParameters = Array.from(urlSearchParams).length > 0;
    const urlWithParameters = window.location.pathname + (hasUrlParameters ? ('?' + urlSearchParams) : '');

    window.history.replaceState(null, null, urlWithParameters);

    // Toggle load more btn
    const hiddenNewsLength = getHiddenNews(isAllSelected, category).length;

    if (hiddenNewsLength == 0) {
        $('.news-list-load-more').hide();
    } else {
        $('.news-list-load-more').show();
    }
}

function getHiddenNews(isAllSelected, category) {
    const newsContainer = $('.ongoing-news-news-list');

    return isAllSelected
        ? $(newsContainer).find('.news-news-teaser:hidden')
        : $(newsContainer).find('.news-news-teaser[data-categories*=' + category + ']:hidden');
}
